import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=7c41ea4f&scoped=true&"
import script from "./Administration.vue?vue&type=script&lang=js&"
export * from "./Administration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c41ea4f",
  null
  
)

export default component.exports